import { render, staticRenderFns } from "./ChipButton.vue?vue&type=template&id=988ec5ec"
import script from "./ChipButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChipButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChipButton.vue?vue&type=style&index=0&id=988ec5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports